import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = " تحويل الارقام من عربي الى انجليزي ";
const DESCRIPTION =
  "استخدم أداة تحويل الأرقام لتحويل الأرقام من النظام العربي إلى النظام الإنجليزي بسرعة وسهولة. أدخل الأرقام العربية وسيتم تحويلها تلقائيًا إلى الأرقام الإنجليزية، مما يسهل عليك العمل مع الأرقام في المستندات والبيانات التي تستخدم النظام الإنجليزي.";
const KEYWORDS =
  "تحويل الأرقام, الأرقام العربية, الأرقام الإنجليزية, تحويل الأرقام من عربي إلى إنجليزي, أداة تحويل الأرقام";
const OG_URL = "https://do-calculate.com/calculator/ar/arabic-to-english/";
const arabicToEnglish = (arabicNum) => {
  const arabicNumbers = "٠١٢٣٤٥٦٧٨٩";
  const englishNumbers = "0123456789";
  return arabicNum
    .split("")
    .map((char) =>
      arabicNumbers.indexOf(char) !== -1
        ? englishNumbers[arabicNumbers.indexOf(char)]
        : char
    )
    .join("");
};
const ArabicToEnglishConverter = () => {
  const [input, setInput] = useState("");
  const [converted, setConverted] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (input) {
        const result = arabicToEnglish(input);
        setConverted(result);
        setError("");
      } else {
        throw new Error("يرجى إدخال رقم عربي.");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>
              محول الأرقام - من العربية إلى الإنجليزية
            </h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تساعدك أداة تحويل الأرقام على تحويل الأرقام من النظام العربي
                  إلى النظام الإنجليزي بكل سهولة. ببساطة، أدخل الأرقام باللغة
                  العربية في الحقل المخصص، وستقوم الأداة بتحويلها إلى الأرقام
                  الإنجليزية تلقائيًا. هذه الأداة مفيدة بشكل خاص عند العمل مع
                  بيانات أو مستندات تحتاج إلى الأرقام الإنجليزية أو عند إدخال
                  الأرقام في برامج تستخدم النظام الإنجليزي.
                </p>
                <p>
                  <strong>كيفية استخدام الأداة:</strong>
                </p>
                <ul>
                  <li>
                    أدخل الأرقام المكتوبة بالأرقام العربية في الحقل المخصص.
                  </li>
                  <li>اضغط على زر "تحويل" للحصول على الأرقام الإنجليزية.</li>
                  <li>تظهر النتيجة مباشرة في الحقل المخصص للتحويل.</li>
                </ul>
                <p>
                  باستخدام هذه الأداة، يمكنك تسريع عملية تحويل الأرقام وتفادي
                  الأخطاء التي قد تحدث عند تحويل الأرقام يدويًا. تعد الأداة
                  مثالية للاستخدام في الأعمال التجارية، التعليم، أو أي مجال آخر
                  يتطلب التعامل مع أنظمة أرقام متعددة.
                </p>
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>محول الأرقام</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          أدخل الأرقام العربية:
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل رقم عربي"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        className="form-control"
                        style={{ width: "50%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                    <br />
                    { error && (
                      <p style={{ color: "red" }}>{error}</p>
                    )}
                    <br />
                    { converted && (
                      <div className="p-3 mb-2 bg-success text-white">
                        <hr />
                        <p>النتيجة:</p>
                        <p>
                          الرقم الإنجليزي: <b>{converted}</b>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {" "}
    </div>
  );
};
export default ArabicToEnglishConverter;
